import React, { useCallback, useEffect, useState } from "react";

import { useEmbedParametersContext } from "../../contexts/embedParametersContext";
import { initializeYleTunnus } from "../../helpers/yleTunnus";
import i18n from "../../service/i18n";
import { usePlayerStore } from "../../store/usePlayerStore";

import {
  NonPlayableButton,
  NonPlayableVideoOverlay,
  NonPlayableVideoText
} from "./NonPlayableStyles";

export const Identification = ({
  refreshComponent
}: {
  refreshComponent: () => Promise<unknown>;
}) => {
  const { useStoreState } = usePlayerStore();
  const setLoginData = useStoreState.setLoginData();
  const { language, theme } = useEmbedParametersContext();
  const [yleTunnusInstance, setYleTunnusInstance] = useState<YleTunnus>();

  const init = useCallback(async () => {
    setYleTunnusInstance(await initializeYleTunnus(language, theme));
  }, [language, theme]);

  useEffect(() => {
    void init();
  }, [init]);

  const onClick = useCallback(async () => {
    try {
      await yleTunnusInstance?.beginIdentification(window.location.href);
      const loggedInUser = await yleTunnusInstance?.loggedInUser();
      if (loggedInUser) {
        setLoginData({
          loggedIn: true,
          residenceInFinland: !!loggedInUser.residenceInFinland,
          userId: loggedInUser.userId
        });
        void refreshComponent();
      }
    } catch (err) {
      console.error("Failed to identify user", err);
    }
  }, [refreshComponent, setLoginData, yleTunnusInstance]);

  return (
    <NonPlayableVideoOverlay>
      <NonPlayableVideoText>
        {i18n("katso_eun_alueella", { language })}
      </NonPlayableVideoText>
      {yleTunnusInstance && (
        <NonPlayableButton
          onClick={onClick}
          text={i18n("aloita", { language })}
        />
      )}
    </NonPlayableVideoOverlay>
  );
};
